import React from "react"
import classNames from "classnames"
import { CurrentTapType } from "../ordersType"
import { useTranslation } from "react-i18next"

export const OrderStatus = ({
  orderStatus,
}: {
  orderStatus: CurrentTapType
}) => {
  const { t } = useTranslation()

  return (
    <span
      className={classNames(
        orderStatus === CurrentTapType.pending
          ? "bg-cyan-30 text-cyan"
          : orderStatus === CurrentTapType.delivered
          ? "text-success bg-success-30"
          : orderStatus === CurrentTapType.cancelled
          ? "bg-warning-30 text-warning"
          : orderStatus === CurrentTapType.rejected
          ? "bg-danger-30 text-danger"
          : orderStatus === CurrentTapType.inProgress
          ? "bg-primary-30 text-primary"
          : "bg-primary-30",
        "px-2 py-1 rounded fw-semibold font-size-12"
      )}
    >
      {t(orderStatus)}
    </span>
  )
}
